// extracted by mini-css-extract-plugin
export var actionButton = "_wo-2";
export var card = "_wo-0";
export var disambiguationList = "_wo-3";
export var errorCard = "_wo-4";
export var row = "_wo-1";